export default "__VITE_ASSET__eIDsNspj__"